import Vue from 'vue'

Vue.mixin({
    computed: {
        $positionName() {
            const user = this.$auth?.user
            if (!user) return null

            const positions = this.$store?.getters?.getPositions || []

            // position_id 기반 매칭 (백엔드가 position_id를 내려줄 때)
            if (user.position_id && positions.length > 0) {
                return positions.find(p => p.id === user.position_id)?.name || null
            }

            // fallback: position 문자열 직접 사용 (백엔드 미지원 시)
            return user.position || null
        },
    },
})
